import { DataSource } from '@/shared/models/data/data-source'
import { ProjectLiteViewModel } from '@/business/project/interfaces/project-lite-view-model'
import { SearchRequest } from '@/shared/interfaces/search-request'
import { PageResponse } from '@/shared/interfaces/page-response'
import { Injector } from '@/config/dependency-injection'
import { ProjectModule } from '@/business/project/store/project-module'

export class ProjectDataSource extends DataSource<ProjectLiteViewModel> {
  private loading = false
  private projectModule = Injector.get(ProjectModule)

  get items(): ProjectLiteViewModel[] {
    return this.projectModule.data.projects
  }

  public destroy(): void {
    this.projectModule.cleanup()
  }

  public fetchData(request: SearchRequest): Promise<PageResponse<ProjectLiteViewModel>> {
    this.loading = true

    return this.projectModule
      .fetchProjects({
        categories: request.categories,
        page: request.page,
        pageSize: request.pageSize,
        query: request.query,
      })
      .finally(() => {
        this.loading = false
      })
  }

  public isLoading(): boolean {
    return this.loading
  }
}
